import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';

function CardRedirection(props) {
  return (
    <>
    <Row xs={1} md={2} className="g-4" style={{width:"100%"}}>
        <Col>
          <Card>
            <Card.Img  variant="top" src="/img/classement.webp" />
            <Card.Body>
              <Card.Title style={{textAlign:"center"}}>Classement</Card.Title>
              <Card.Text>
                    
              </Card.Text>
              <Link to={`/${props.type}/tableau-de-bord/classement`}>
                <Button className="custom-btn" variant="primary" >Voir le classement</Button>
                </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card>
            <Card.Img variant="top" src="/img/match2.webp" />
            <Card.Body>
              <Card.Title style={{textAlign:"center"}}>Matchs {props.type === 'coach' && (' et tournois')}</Card.Title>
              <Card.Text>

              </Card.Text>
              <Link to={`/${props.type}/tableau-de-bord/match`}>
                    <Button  className="custom-btn" variant="primary" >Voir les matchs</Button>
              </Link>
              &nbsp;
              {props.type === 'coach' && (
                <Link to={`/${props.type}/tableau-de-bord/tournois`}>
                      <Button  className="custom-btn" variant="primary" >Voir les tournois</Button>
                </Link>
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col>
          <Card>
            <Card.Img variant="top" src="/img/tactique.jpg" />
            <Card.Body>
              <Card.Title style={{textAlign:"center"}}>Sélection</Card.Title>
              <Card.Text>

              </Card.Text>
              <Link to={`/${props.type}/tableau-de-bord/selection`}>
                    <Button  className="custom-btn" variant="primary" >Voir les sélection</Button>
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col>
          {props.type === 'coach' ? (
            <Card>
              <Card.Img variant="top" src="/img/tournoi.jpg"   />
              <Card.Body>
                <Card.Title style={{textAlign:"center"}}>Arbitrage</Card.Title>
                <Card.Text>
          
                </Card.Text>
                <Link to={`/${props.type}/tableau-de-bord/arbitrage`}>
                  <Button  className="custom-btn" variant="primary" >Voir les candidature</Button>
                </Link>
              </Card.Body>
            </Card>
          ):(
            <Card>
              <Card.Img variant="top" src="/img/tournoi.jpg"   />
              <Card.Body>
                <Card.Title style={{textAlign:"center"}}>Tournois</Card.Title>
                <Card.Text>
          
                </Card.Text>
                <Link to={`/${props.type}/tableau-de-bord/tournois`}>
                  <Button  className="custom-btn" variant="primary" >Voir les tournois</Button>
                </Link>
              </Card.Body>
            </Card>

          )}
        </Col>
    </Row>

  

    </>
  );
}

export default CardRedirection;